import {Component, EventEmitter, Input, Output} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {FormDescriptor, GroupZoneDescriptor, TabSheetDescriptor} from '../../form-generator/form-generator.interfaces';

@Component({
  selector: 'gp-contract-data-group-menu',
  templateUrl: './contract-data-group-menu.component.html',
  styleUrls: ['./contract-data-group-menu.component.scss']
})
export class ContractDataGroupMenuComponent extends Destroyable {

  @Input() public descriptor: FormDescriptor;
  @Input() public activeGroupZone: GroupZoneDescriptor;
  @Input() public activeTabSheet: TabSheetDescriptor;
  @Output() selectedTabSheetWithGroupZoneChange
    = new EventEmitter<{ groupZone: GroupZoneDescriptor, tabSheet: TabSheetDescriptor }>();

  public selectTabSheetWithGroupZone(groupZone: GroupZoneDescriptor, tabSheet: TabSheetDescriptor): void {
    this.activeGroupZone = groupZone;
    this.activeTabSheet = {...tabSheet, active: true};
    this.selectedTabSheetWithGroupZoneChange.emit({groupZone, tabSheet: this.activeTabSheet});
  }

}
